import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shipping-cost"
// Catches a mistyped shipping charge (7800 instead of 78.00) before it lands on
// the invoice. Warns inline as they type and confirms again on submit.
export default class extends Controller {
  static targets = ["amount", "warning"]
  static values = { threshold: Number }

  checkAmount(){
    if(!this.hasWarningTarget){ return }
    const amount = this.amount()
    const high = this.isHigh(amount)
    this.amountTarget.classList.toggle("border-danger", high)
    this.warningTarget.hidden = !high
    if(high){
      this.warningTarget.innerHTML = `${this.currency(amount)} is unusually high for shipping. Check the decimal point.`
    }
  }

  confirmAmount(event){
    const amount = this.amount()
    if(!this.isHigh(amount)){ return }
    const message = `The shipping cost of ${this.currency(amount)} is above ${this.currency(this.thresholdValue)}.\n\nIs this correct?`
    if(!confirm(message)){
      event.preventDefault()
      this.amountTarget.focus()
      this.amountTarget.select()
    }
  }

  amount(){
    if(!this.hasAmountTarget){ return NaN }
    return parseFloat(this.amountTarget.value)
  }

  isHigh(amount){
    if(isNaN(amount)){ return false }
    if(!(this.thresholdValue > 0)){ return false }
    return amount > this.thresholdValue
  }

  currency(amount){
    return amount.toLocaleString("en-US", {style: "currency", currency: "USD"})
  }

}
